/**
 * A function that always returns the input that is passed to it.
 * @param x The value to return
 * @returns The value that was passed in
 */
export const identity = <T>(x: T): T => x
